// import * as React from 'react'
// import './Modal.css'
// type ModalProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
//   onClose?: () => void;
// };

// const Modal = React.forwardRef<HTMLDivElement, ModalProps>(({ className = "", onClose, children, ...props }, ref) => {
//   const internalRef = React.useRef<HTMLDivElement>(null);
//   const modalRef = (ref as React.RefObject<HTMLDivElement>) || internalRef;
// React.useEffect(() => {
//   document.body.style.overflow = "hidden";
//   return () => {
//     document.body.style.overflow = "auto";
//   };
// }, []);
// React.useEffect(() => {
//   const handleEsc = (e: KeyboardEvent) => {
//     if (e.key === "Escape") onClose?.();
//   };
//   window.addEventListener("keydown", handleEsc);
//   return () => window.removeEventListener("keydown", handleEsc);
// }, [onClose]);

//   React.useEffect(() => {
//     const handleClickOutside = (event: MouseEvent) => {
//       if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
//         onClose?.();
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, [onClose, modalRef]);

//   return (
//     <div className="overlay">
//       <div ref={modalRef} className={`modal ${className}`.trim()} {...props}>
//        <div className='modal-content'> {children}</div>
//       </div>
//     </div>
//   );
// });

// Modal.displayName = "Modal";

// export { Modal };
import * as React from "react";
import ReactDOM from "react-dom";
import "./Modal.css";

type ModalProps = {
  onClose?: () => void;
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
};

const Modal = React.forwardRef<HTMLDivElement, ModalProps>(
  ({ className = "", style = {}, onClose, children }, ref) => {
    const internalRef = React.useRef<HTMLDivElement>(null);
    const modalRef = (ref as React.RefObject<HTMLDivElement>) || internalRef;

    // Disable body scroll
    React.useEffect(() => {
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = "auto";
      };
    }, []);

    // Close on outside click
    React.useEffect(() => {
      const handleClickOutside = (event: MouseEvent) => {
        if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
          onClose?.();
        }
      };

      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [onClose, modalRef]);

    // Close on ESC
    React.useEffect(() => {
      const handleEsc = (e: KeyboardEvent) => {
        if (e.key === "Escape") onClose?.();
      };
      window.addEventListener("keydown", handleEsc);
      return () => window.removeEventListener("keydown", handleEsc);
    }, [onClose]);

    const modalElement = (
      <div className="overlay">
        <div ref={modalRef} className={`modal ${className}`} style={style}>
          <div className="modal-content">{children}</div>
        </div>
      </div>
    );

    return ReactDOM.createPortal(modalElement, document.body);
  }
);

Modal.displayName = "Modal";

export { Modal };
